import { startOfYear } from 'date-fns'

export const priorityViews = [
  { label: 'Trending', value: 'trending' },
  {
    label: 'Most Views',
    value: 'most-views',
  },
]

export const maxDateRange = {
  from: startOfYear(new Date()),
  to: new Date(),
}
